import { type ReactNode } from 'react';
import * as Sentry from '@sentry/react';
import ErrorPage from './ErrorPage';

interface ErrorBoundaryProps {
  children: ReactNode;
}

const ErrorBoundary = ({ children }: ErrorBoundaryProps) => {
  const handleError = (error: unknown, componentStack: string) => {
    if ((error as Error).name === 'ChunkLoadError' && !window.location.search.includes('reloaded')) {
      const { location } = window;
      location.href = `${location.origin}${location.pathname}${location.search || '?'}&reloaded`;
    } else {
      Sentry.captureException(error, { extra: { componentStack } });
    }
  };

  return (
    <Sentry.ErrorBoundary fallback={<ErrorPage />} onError={handleError}>
      {children}
    </Sentry.ErrorBoundary>
  );
};

export default ErrorBoundary;
